export enum FieldNames {
	IUnderstandConsequences = 'IUnderstandConsequences',
}

export type FormValues = {
	[FieldNames.IUnderstandConsequences]: boolean
}
